"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var MediaManagerImage_1 = __importDefault(require("@sportnet/ui/lib/MediaManagerImage"));

var em_1 = __importDefault(require("polished/lib/helpers/em"));

var react_1 = __importStar(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var sportnet_utilities_1 = require("sportnet-utilities");

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var Desc = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  ", "};\n"], ["\n  font-weight: 400;\n  font-size: ", ";\n  line-height: ", ";\n  ", "};\n"])), em_1["default"](12), em_1["default"](20), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), utilities_1.emphasizeColor(0.35, theme.app.textColor, true));
});
var ImageWrapper = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  display: inline-block;\n"], ["\n  position: relative;\n  display: inline-block;\n"])));
var ImageContainer = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));

var WidgetPhoto =
/** @class */
function (_super) {
  __extends(WidgetPhoto, _super);

  function WidgetPhoto() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  WidgetPhoto.prototype.render = function () {
    var description = '',
        author = '',
        source = '',
        name = '',
        picture = {};
    var uri = sportnet_utilities_1.getProp(this.props, ['data', 'uri'], '');

    if (uri) {
      // old format for photos
      var data = sportnet_utilities_1.getProp(this.props, ['data'], {});
      description = data.description;
      author = data.author;
      source = data.source;
      name = data.name;
      picture = data;
    } else {
      var data = sportnet_utilities_1.getProp(this.props, ['data', 'picture'], {});
      description = data.description;
      author = data.author;
      source = data.source;
      name = data.name;
      picture = data;
    }

    var textArray = [];

    if (author) {
      textArray = ["autor: " + author];
    }

    if (source) {
      textArray = __spreadArrays(textArray, ["zdroj: " + source]);
    }

    if (name) {
      textArray = __spreadArrays(textArray, [name]);
    }

    return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(ImageContainer, null, react_1["default"].createElement(ImageWrapper, null, react_1["default"].createElement(MediaManagerImage_1["default"], {
      picture: picture,
      naturalWidth: 870,
      naturalHeight: 0
    })), react_1["default"].createElement(Desc, null, description && description, react_1["default"].createElement("br", null), textArray.length !== 0 && textArray.join(', '))));
  };

  return WidgetPhoto;
}(react_1.PureComponent);

exports["default"] = WidgetPhoto;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;